import React from 'react';
import { Header } from '../components/Header';
import { Button } from '../components/Button';
import { SearchXIcon } from 'lucide-react';
interface EmptyScreenProps {
  onLogout: () => void;
  onClearFilters: () => void;
}
export function EmptyScreen({
  onLogout,
  onClearFilters
}: EmptyScreenProps) {
  return <div className="h-screen flex flex-col bg-navy" data-id="element-659">
      <Header caseName="Smith v. Acme Corp" onLogout={onLogout} data-id="element-660" />

      <div className="flex-1 flex items-center justify-center p-4" data-id="element-661">
        <div className="text-center max-w-md" data-id="element-662">
          <div className="w-16 h-16 bg-navy-light rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-663">
            <SearchXIcon className="w-8 h-8 text-gray-500" data-id="element-664" />
          </div>
          <h2 className="text-2xl font-serif text-white mb-2" data-id="element-665">
            No documents found
          </h2>
          <p className="text-gray-400 mb-8" data-id="element-666">
            Try adjusting your search or filters to find what you're looking
            for.
          </p>
          <Button onClick={onClearFilters} data-id="element-667">Clear Filters</Button>
        </div>
      </div>
    </div>;
}